import { createAction, props } from '@ngrx/store';

export const getSuppliers = createAction('[Supplier] Get Suppliers');

export const getSuppliersSuccess = createAction('[Supplier] Get Suppliers Success', props<{ data: any }>());

export const getSuppliersFailure = createAction('[Supplier] Get Suppliers Failure', props<{ error: any }>());
